<template>
  <div id="unggas-nasional-data-distribusi-hatchery-list" data-app>

    <!--begin::Engage Widget 1-->
    <div class="card card-custom card-stretch gutter-b">
        <div class="card-body d-flex p-0 bg-white">
            <div class="flex-grow-1 p-8 card-rounded bgi-no-repeat d-flex align-items-center"
                style="background-position: right bottom; background-size: auto 100%; background-image: url(media/svg/humans/custom-8.svg)">

                <div class="row w-100">
                    <div class="col-12 col-sm-9">
                        <h4 class="text-danger font-weight-bolder">Search Hatchery</h4>
                        <div class="d-flex flex-center py-2 px-6 bg-light rounded">
                            <span class="svg-icon svg-icon-lg svg-icon-info">
                                <!--begin::Svg Icon-->
                                <inline-svg src="media/svg/icons/General/Search.svg" />
                                <!--end::Svg Icon-->
                            </span>
							<input type="text" v-model="search" class="form-control border-0 font-weight-bold pl-2 bg-light" placeholder="Search Your Hatchery">
						</div>
                    </div>
                    <div class="col-12 col-sm-3">

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--end::Engage Widget 1-->

    <div v-if="!isBusy">
        <!--Begin::Row-->
        <b-row v-if="filteredItem.length">
            <b-col cols="12" lg="4" md="6" sm="6" 
                v-for="(val, key) in filteredItem" 
                :key="key" 
                class="py-0"
            >
                <!--begin::Stats--> 
                <div class="card card-custom bgi-no-repeat card-stretch gutter-b cursor-pointer"
                    :style="`background-position: right top; background-size: 30% auto; background-image: url(media/svg/shapes/${getSVG()}`"
                    @contextmenu.prevent="$refs.menu.open($event, val)"
                    @click="$router.push(`/unggas-nasional/distribusi/${val._id}`)"
                >

                    <!--begin::body-->
                    <div class="card-body d-flex flex-column">
                        <div class="flex-grow-1">
                            <!--begin::Info-->
                            <div class="d-flex align-items-center pr-2 mb-2">
                                <span class="text-dark font-weight-bolder text-hover-primary font-size-h4">
                                    Hatcery {{ val.hatchery }}
                                </span>
                                <span v-if="peringatan(val)" v-b-tooltip.hover :title="peringatan(val)" class="svg-icon svg-icon-lg svg-icon-danger ml-2 m-0">
                                    <!--begin::Svg Icon-->
                                    <inline-svg src="media/svg/icons/Code/Warning-1-circle.svg"/>
                                    <!--end::Svg Icon-->
                                </span>
                            </div>
                            <!--end::Info-->

                            <!--begin::Desc-->
                            <p class="text-dark-50 font-weight-normal font-size-sm mt-2">
                                Jumlah mesin {{ val.mesin_count | nominal }} unit dengan kapasitas terpasang {{ val.mesin_sum_kapasitas | nominal }} butir
                            </p>
                            <!--end::Desc-->
                        </div>
                    </div>
                    <!--end::Body-->
                </div>
                <!--end::Stats-->
            </b-col>
        </b-row>
        <!--End::Row-->

        <div v-else class="card card-custom gutter-b mt-8" style="height: 150px">
            <!--begin::Body-->
            <div class="card-body d-flex align-items-center justify-content-between flex-wrap">
                <div class="mr-2">
                    <h3 class="font-weight-bolder">Tidak ada Hatchery</h3>
                    <div class="text-dark-50 font-size-lg mt-2">
                        Silahkan tambah data hatchery terlebih dahulu
                    </div>
                </div>
                <a @click="$router.push({ name: 'master-data-hatchery-add' })" class="cursor-pointer btn btn-primary font-weight-bold py-3 px-6">Tambah Hatchery</a>
            </div>
            <!--end::Body-->
        </div>
    </div>
    <div v-else>
        <!--Begin::Row-->
        <b-row>
            <b-col cols="12" lg="4" md="6" sm="6" class="py-0">
                <!--begin::Stats--> 
                <div class="card card-custom bgi-no-repeat card-stretch gutter-b cursor-pointer"
                    :style="`background-position: right top; background-size: 30% auto; background-image: url(media/svg/shapes/${getSVG()}`">
                    <!--begin::body-->
                    <div class="card-body d-flex flex-column">
                        <CodeLoader></CodeLoader>
                    </div>
                    <!--end::Body-->
                </div>
                <!--end::Stats-->
            </b-col>
            <b-col cols="12" lg="4" md="6" sm="6" class="py-0">
                <!--begin::Stats--> 
                <div class="card card-custom bgi-no-repeat card-stretch gutter-b cursor-pointer"
                    :style="`background-position: right top; background-size: 30% auto; background-image: url(media/svg/shapes/${getSVG()}`">
                    <!--begin::body-->
                    <div class="card-body d-flex flex-column">
                        <CodeLoader></CodeLoader>
                    </div>
                    <!--end::Body-->
                </div>
                <!--end::Stats-->
            </b-col>
            <b-col cols="12" lg="4" md="6" sm="6" class="py-0">
                <!--begin::Stats--> 
                <div class="card card-custom bgi-no-repeat card-stretch gutter-b cursor-pointer"
                    :style="`background-position: right top; background-size: 30% auto; background-image: url(media/svg/shapes/${getSVG()}`">
                    <!--begin::body-->
                    <div class="card-body d-flex flex-column">
                        <CodeLoader></CodeLoader>
                    </div>
                    <!--end::Body-->
                </div>
                <!--end::Stats-->
            </b-col>
        </b-row>
        <!--End::Row-->
    </div>

    <vue-context ref="menu" v-slot="{ data }"
        class="navi navi-hover"
        :lazy="false"
    >
        <li class="navi-item">
            <a class="navi-link active" href="#">
                <span class="navi-icon"><i class="flaticon2-analytics"></i></span>
                <span class="navi-text">Messages</span>
                <span class="navi-label">
                    <span class="label label-danger label-rounded">2</span>
                </span>
            </a>
        </li>
        <li class="navi-item">
            <a class="navi-link" href="#">
                <span class="navi-icon"><i class="flaticon2-pie-chart-2"></i></span>
                <span class="navi-text">{{ (data ? data.hatchery : null) }}</span>
            </a>
        </li>
        <li class="navi-item">
            <a class="navi-link" href="#">
                <span class="navi-icon"><i class="flaticon2-layers"></i></span>
                <span class="navi-text">Profile</span>
            </a>
        </li>
        <li class="navi-item">
            <a class="navi-link" href="#">
                <span class="navi-icon"><i class="flaticon2-box-1"></i></span>
                <span class="navi-text">Tasks</span>
                <span class="navi-label">
                    <span class="label label-warning label-rounded">5</span>
                </span>
            </a>
        </li>
    </vue-context>
    
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CodeLoader } from 'vue-content-loader'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import DistribusiService from "@/core/services/api/nasional/distribusi.service";
import ErrorService from "@/core/services/error.service";

import VueContext from 'vue-context';
import 'vue-context/src/sass/vue-context.scss';

export default {
  name: "unggas-nasional-data-distribusi-hatchery-list",
  components: {
    VueContext,
    CodeLoader,
  },  
  data() {
    return {
      search: '',
      isBusy: true,
      items: [],
      svg: ['abstract-1.svg', 'abstract-2.svg', 'abstract-3.svg', 'abstract-4.svg', 'abstract-5.svg'],
    }
  },
  computed: {
    ...mapGetters(["currentUser"]),
    filteredItem() { 
        return this.items.filter((item) => item.hatchery.toLowerCase().includes(this.search.toLowerCase()));
    }
  },
  methods: {
    getSVG () {
        return this.svg[Math.floor(Math.random() * this.svg.length)];
    },
    peringatan (itm) {
        return null
    },
    getData () {
      DistribusiService.getHatcheryList()
        .then((res) => {
            if (!res.data.status) {
                ErrorService.message(res.data)
                this.items = []
                this.isBusy = false
                return;
            }
            this.items = res.data.data
            this.isBusy = false
        })
        .catch((err) => {
          this.items = []
          this.isBusy = false
          return ErrorService.status(err)
        })
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "UN Data Distribusi" }]);
    if (!this.currentUser.menu.nasional_distribusi) {
      return this.$router.push({ name: 'dashboard'}).catch(()=>{})
    }
    this.getData()    
  },
};
</script>

<style lang="scss">
#unggas-nasional-data-distribusi-hatchery-list{
    .v-context{
        border: 0 solid rgba(0, 0, 0, 0.15) !important;
        border-radius: 0.42rem !important;
        -webkit-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15) !important;
        box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15) !important;
    }
}
</style>